<template>
    <div>
        <div class="d-flex flex-wrap gap-md-3 side-nav-padding" style="gap: 1px; background: var(--nav-control-bg);">
            <div class="image-editor-card-secondary gap-4 text-center flex-grow-1" style="flex-basis: 110px">
                <p class="fs-5 fw-600">{{$trans('storefront::image_editor.add_file')}}</p>
                <p class="fs-6 text-muted fw-500"> PNG, JPG, SVG, PDF, TIF, GIF, BMP, AVIF </p>
                <input type="file" id="file" :accept="store.mediaOptions.mimes" @change="uploadImage" hidden />
                <label for="file" class="btn btn-secondary btn-medium text-nowrap cursor-pointer mt-auto">{{$trans('storefront::image_editor.browse_files')}}</label>
            </div>

            <div class="image-editor-card-secondary gap-4 text-center flex-grow-1" style="flex-basis: 280px">
                <template v-if="store.instruction === '' && store.instruction_files.length === 0">
                    <p class="fs-5 fw-600">{{$trans('storefront::image_editor.optional')}}</p>
                    <p class="fs-6 text-muted fw-500">{{$trans('storefront::image_editor.add_effect_mask_or_instructions_description')}}</p>
                    <label class="btn btn-secondary btn-medium cursor-pointer text-nowrap" @click="$refs['instruction-modal'].open()">{{$trans('storefront::image_editor.add_effect_mask_or_instructions')}}</label>
                </template>

                <template v-else>
                    <p class="fs-5 fw-600">{{$trans('storefront::image_editor.effect_layer')}}</p>
                    <p class="fs-6 text-muted fw-500">{{$trans('storefront::image_editor.add_effect_mask_or_instructions_description')}}</p>
                    <label class="btn btn-secondary btn-medium cursor-pointer text-nowrap" @click="$refs['instruction-modal'].open()">{{$trans('storefront::image_editor.edit_effect_mask_or_instructions')}}</label>
                </template>
            </div>

            <draft class="flex-grow-1"></draft>
        </div>

        <instruction-modal ref="instruction-modal"></instruction-modal>
    </div>
</template>

<script>

import { fabric } from "fabric";
import { useImageEditorStore } from '../store';
import { functions } from "../imageEditor";
import InstructionModal from "../modals/InstructionModal";
import Draft from "../components/drafts/Draft";

export default {
    components: {Draft, InstructionModal},
    setup() {
        const store = useImageEditorStore();
        return { store };
    },
    methods: {
        async uploadImage(e) {
            let file = e.target.files[0];
            let app = this;
            if (file.type === 'application/pdf') {
                let pdf = new fabric.PdfObject(file);
                this.handleObject(pdf);
            } else {
                let img = new Image();
                img.src = await this.loadImage(file);

                img.onload = () => {
                    let image = new fabric.Image(img);
                    this.handleObject(image);
                }
            }
        },
        async loadImage(file) {
            let reader = new FileReader();
            reader.readAsDataURL(file);
            await new Promise(resolve => reader.onload = resolve);
            return reader.result;
        },
        handleObject(obj) {
            obj.scaleToWidth(this.store.width*300*0.8);
            obj.set({ originX: 'center', originY: 'center'});
            obj.applyFilters();

            this.store.canvas.add(obj);
            functions.updateMask();
        },
        openModal(name) {
            let modal = this.$refs[name].$el;
            $(modal).modal({backdrop: false});
        },
    }
}

</script>
